import React from "react";
import "./CareerPageContent.css";
import { Link } from "react-router-dom";

const CareerPageContent = () => {
    return (
        <>
            <div className="career-hero-img">
                <img className="hero-img" src="/Assets/CareerPageImages/opportunity.webp" />
            </div>
            <div className="career-page">
                <div className="career-page-content">
                    {/* Row 1 */}
                    <div className="career-row">
                        <div className="career-block wide">
                            <div className="image-text-block">
                                <div className="image-wrapper">
                                    <img
                                        src="/Assets/CareerPageImages/c1.webp"
                                        alt="Global Recruitment"
                                        className="career-image"
                                    />
                                </div>
                                <Link to="/career/jobs" className="career-content-wrapper" >
                                    <div className="career-content">
                                        <h3>Global <br /> Recruitment</h3>
                                        <p>Check out our current openings here</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="career-block narrow blue-box">
                            <div className="text-box-content">
                                <h3>Did you know that...</h3>
                                <p>
                                    Callistus has the world's largest range of 15 types of blinds
                                </p>
                            </div>
                            <Link to="/career/jobs" className="careerRef-img">
                                <img src="/Assets/CareerPageImages/ref.png" />
                            </Link>
                        </div>
                    </div>

                    {/* Row 2 */}
                    <div className="career-row Mobile-r_row">
                        <div className="career-block narrow blue-box">
                            <div className="text-box-content">
                                <h3>VISION</h3>
                                <p>
                                    We significantly aim to become one of the top five leading multinational organizations in Window covering industry by leveraging our expertise worldwide.
                                </p>
                            </div>
                        </div>
                        <div className="career-block wide Mobile-r_row">
                            <div className="image-text-block">
                                <div className="career-content-wrapper" >
                                    <div className="career-content">
                                        <h3>Growth <br />Opportunity</h3>
                                        <p>Accelerate your growth with a multinational organization and experience a wide range of opportunity with progression</p>
                                    </div>
                                </div>
                                <div className="image-wrapper image-wrapper-row2">
                                    <img
                                        src="/Assets/CareerPageImages/cts.webp"
                                        alt="Did you know that..."
                                        className="career-image"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Row 3 */}
                    <div className="career-row">
                        <div className="career-block wide">
                            <div className="image-text-block">
                                <div className="image-wrapper">
                                    <img
                                        src="/Assets/CareerPageImages/juso.webp"
                                        alt="MISSION"
                                        className="career-image"
                                    />
                                </div>
                                <Link to="/career/jobs" className="career-content-wrapper" >
                                    <div className="career-content">
                                        <h3>Who Can <br /> Join US</h3>
                                        <p>
                                            Enthusiastic and intellectual professionals who are growth oriented and aggressive to achieve soaring heights within the organization as a team.
                                        </p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="career-block narrow blue-box">
                            <div className="text-box-content">
                                <h3>MISSION</h3>
                                <p>
                                    Improve the quality of life of the society and community at large wherein major focus is on value creation based on Leadership with Trust.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default CareerPageContent;
